import { Box, Divider, SimpleGrid, Center, Button } from '@chakra-ui/react';
import lodash from 'lodash';
import React, { useState } from 'react';

import { SettingsEditForm } from './SettingsUserEditForm';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { LabeledDetail } from '~/packages/common-frontend/components/LabeledDetail';

const { capitalize } = lodash;

export const SettingsUserContainer = () => {
  const { user } = useUserAuthOrThrow();
  const [editUserSettings, toggleEditUserSettings] = useState(false);

  return editUserSettings ? (
    <>
      <SettingsEditForm setEditMode={toggleEditUserSettings} />
      <Box height="10px" />
    </>
  ) : (
    <>
      <Box>
        <SimpleGrid columns={{ sm: 1, md: 2 }} spacingX={10} spacingY="20px">
          <LabeledDetail label="Organization">
            {user.organization.name}
          </LabeledDetail>
          <LabeledDetail label="Industry">
            {user.organization.industry}
          </LabeledDetail>
        </SimpleGrid>

        <Center height="50px">
          <Divider />
        </Center>

        <SimpleGrid columns={{ sm: 1, md: 2 }} spacingX={10} spacingY="20px">
          <LabeledDetail label="First Name">{user.firstName}</LabeledDetail>
          <LabeledDetail label="Last Name">{user.lastName}</LabeledDetail>
          <LabeledDetail label="Email">{user.email}</LabeledDetail>
          <LabeledDetail label="Role">
            {capitalize(user.roleType)}
          </LabeledDetail>
        </SimpleGrid>
      </Box>
      <Box height="60px" />
      <Button
        aria-label="Edit"
        variant="secondary"
        colorScheme="v2-aurora"
        onClick={() => toggleEditUserSettings(true)}
      >
        Edit
      </Button>
    </>
  );
};
